var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"protect-measures-main",class:{ 'protect-measures-main-mobile': _vm.isMobile}},[_c('Base-title',{attrs:{"title":"贝壳隐私保护措施"}}),_c('MeasuresSwiper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }